import { render } from "./Trailer.vue?vue&type=template&id=6cadb65c"
import script from "./Trailer.vue?vue&type=script&lang=js"
export * from "./Trailer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__